import script from "./DetailsOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsOverlay.vue?vue&type=style&index=0&id=2e8623ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e8623ca"]])

export default __exports__